<div class="ap-margin-bottom-3">{{ 'property.purchase-price.amount' | coApplicantPipe: store.hasCoApplicant | apContent }}</div>
<ap-amount-input
    id="purchasePriceAmount"
    [helpText]="'property.purchase-price.help-text' | apContent"
    [showSymbol]="true"
    [numberOfDecimals]="0"
    [formControl]="mainApplicantControl"
></ap-amount-input>

<additional-info
    [key]="questionKey"
    titleKey="property.purchase-price.amount.additional-info.text"
    contentKey="{{
        (this.store.getPropertyType() | async) === propertyType.NEW_BUILD
            ? 'property.purchase-price.additional-info.content.new'
            : 'property.purchase-price.additional-info.content.existing'
    }}"
    modalUrlKey="property.purchase-price.amount.additional-info.text"
></additional-info>

@if (!store.isSummary) {
    <next-button (click)="nextQuestion()"></next-button>
}
